<template>
    <div>
        <template v-for="(option) in options">
            <!-- Si la opción tiene hijos, se renderiza un acordeón colapsable -->
            <div v-if="(option.all_options && option.all_options.length) || (option.options && option.options.length)" :key="'group_' + option.id">
                <a
                    class="nav-link collapsed"
                    href="javascript:void(0);"
                    data-toggle="collapse"
                    :data-target="'#menu_collapse_' + option.id"
                    aria-expanded="false"
                    :aria-controls="'menu_collapse_' + option.id"
                >
                    <div class="nav-link-icon" v-html="option.icon"></div>
                    {{ option.name }}
                    <div class="sidenav-collapse-arrow">
                        <i class="fas fa-angle-down"></i>
                    </div>
                </a>
                <div
                    class="collapse"
                    :id="'menu_collapse_' + option.id"
                    :data-parent="parentId ? ('#' + parentId) : '#accordionSidenav'"
                >
                    <nav class="sidenav-menu-nested nav accordion" :id="'accordionSidenav_' + option.id">
                        <!-- Recursividad inyectando el componente a sí mismo -->
                        <MenuItemRecursive
                            :options="option.all_options || option.options"
                            :parentId="'accordionSidenav_' + option.id"
                            :appTypes="appTypes"
                            :currentAppName="currentAppName"
                        />
                    </nav>
                </div>
            </div>

            <!-- Si no tiene hijos, es un link final resolviendo el subdominio de App -->
            <template v-else>
                <!-- Si pertenece al dominio local, usa router-link interno -->
                <router-link
                    v-if="option.app === currentAppName"
                    :key="'link_' + option.id"
                    :to="option.route"
                    class="nav-link"
                >
                    <div class="nav-link-icon" v-html="option.icon"></div>
                    {{ option.name }}
                </router-link>

                <!-- Si pertenece a un dominio externo (ERP->HC o HC->ERP), usa un link absoluto a href -->
                <a
                    v-else
                    :key="'ext_link_' + option.id"
                    class="nav-link"
                    :href="`${getAppDomain(option.app)}${option.route}`"
                >
                    <div class="nav-link-icon" v-html="option.icon"></div>
                    {{ option.name }}
                </a>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "MenuItemRecursive",
    props: {
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        parentId: {
            type: String,
            default: ""
        },
        appTypes: {
            type: Array,
            required: true,
            default: () => []
        },
        currentAppName: {
            type: String,
            required: true
        }
    },
    methods: {
        getAppDomain(appName) {
            const found = this.appTypes.find(app => String(app.name) === String(appName));
            // Aseguramos de quitar algún slash final en el dominio base si lo trajera de BD
            return found && found.domain ? found.domain.replace(/\/$/, '') : '';
        }
    }
};
</script>
